<div class="flex items-center">
  <IDropdown [items]="params.items" placement="bottom-end">
    <IButton [icon]="params.icon" [label]="params.label" color="gray" size="sm" variant="ghost" />
  </IDropdown>
</div>
